import React from 'react';
import { Box, Typography } from '@mui/material';
import { statusBadgeSx, statusBarSx, statusLabelSx } from '../css/revenueItems.styles';
import { getAmountModeMeta } from '../utils/revenueItems.utils';

const AmountTypeBadge = ({ amountMode }) => {
  const meta = getAmountModeMeta(amountMode);
  return (
    <Box sx={{ ...statusBadgeSx, bgcolor: meta.bgColor }}>
      <Box sx={{ ...statusBarSx, bgcolor: meta.color }} />
      <Typography sx={{ ...statusLabelSx, color: meta.color }}>{meta.label}</Typography>
    </Box>
  );
};

export default AmountTypeBadge;
